// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2lv42","container":"styles_container__FmUtt","title":"styles_title__1JGkU","wrapper":"styles_wrapper__1bCBp","answer":"styles_answer__2UzCQ"};